import {storeSessionKey, TOKEN_KEY, ENV_KEY, USERNAME_KEY, TOKEN_EXPIRE_TIME} from '../../util/storage'
import {getTokenExpireTime} from '../../util/helpers'

export const fetchToken = (data, history) => ({apis}) => {
  const reqData = {
    username: data.username,
    password: data.password,
  }
  const config = {
    'Content-Type': 'application/json',
  }
  const payload = apis.authenticateUser(reqData, config, data.env).map((x) => {
    if (x && x.token) {
      storeSessionKey(TOKEN_KEY, x.token)
      storeSessionKey(ENV_KEY, data.env)
      storeSessionKey(USERNAME_KEY, data.username)
      storeSessionKey(TOKEN_EXPIRE_TIME, '' + getTokenExpireTime())
      history.push('/search')
    }
    return x
  })
  return {
    type: 'FETCH_TOKEN',
    payload,
  }
}



// WEBPACK FOOTER //
// ./src/store/login/actions.js